module.exports = __webpack_public_path__ + "img/mask-title.svg?bc24b96e3448ffbd730693c64db91cf7";